import Reflux from "reflux";

export default Reflux.createActions([
  "follow",
  "unFollow",
]);
